import trackerConstants from './constants';

const getPage = () => {
  // Get last chunk of pathname
  const page = window.location.pathname.substring(window.location.pathname.lastIndexOf('/') + 1);
  return trackerConstants.BOOKING_GTM_MAPPING[page] || page || 'homepage';
};

export default getPage;
